export const createStyles = (theme: any) => {
  const { palette } = theme;
  const isDark = palette?.mode === 'dark';

  return {
    sidebarWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      overflow: 'hidden',
      fontFamily: theme?.typography?.fontFamily,
    },
    sidebarNavigation: {
      px: { xs: '16px', md: '12px' },
      pt: { xs: '16px', md: '12px' },
      marginLeft: '-8px',
    },
    sidebarHeader: {
      display: 'flex',
      flexDirection: 'column',
      px: '12px',
      minHeight: 0,
    },
    assignmentTitle: {
      display: '-webkit-box',
      my: '16px',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      fontSize: '20px',
      fontWeight: 500,
    },
    newExtension: {
      height: '42px',
      fontWeight: '500',
      mb: '16px',
    },
    sidebarContent: {
      flex: 1,
      overflowY: 'auto',
      listStyle: 'none',
      m: 0,
      px: '12px',
      pb: '12px',
    },
    extensions: {
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      borderRadius: '8px',
    },
    extensionItem: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      gap: '8px',
      minHeight: '48px',
      px: '8px',
      [theme.breakpoints.up('md')]: {
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        '&:hover .extension-action': {
          display: 'inline-flex',
        },
      },
      borderBottom: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    extensionIcon: {
      flexShrink: 0,
    },
    extensionSelectButton: {
      alignItems: 'center',
      alignSelf: 'stretch',
      background: 'none',
      border: 0,
      color: 'inherit',
      cursor: 'pointer',
      display: 'flex',
      flex: 1,
      font: 'inherit',
      gap: '8px',
      minWidth: 0,
      p: 0,
      textAlign: 'left',
      '&:focus-visible': {
        borderRadius: '4px',
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px',
      },
    },
    extensionTitle: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      fontSize: '14px',
      minWidth: 0,
    },
    extensionName: {
      display: { xs: '-webkit-box', md: 'block' },
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: { xs: 'normal', md: 'nowrap' },
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: { xs: 2, md: 'unset' },
    },
    extensionCount: {
      flexShrink: 0,
      ml: '4px',
    },
    extensionItemDetails: {
      alignItems: 'center',
      display: 'flex',
    },
    menuIcon: {
      flexShrink: 0,
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    menuButtonWrapper: {
      display: { xs: 'inline-flex', md: 'none' },
    },
    extensionMenu: {
      '& .MuiPaper-root, & .MuiMenu-paper, & .MuiPopover-paper, & .MuiMenu-list, & .MuiList-root':
        {
          backgroundColor: isDark ? '#363636 !important' : undefined,
          color: isDark ? '#ffffff' : undefined,
        },
    },
    visibilityIcon: {
      flexShrink: 0,
      color: isDark ? '#FFFFFF' : '#000000DE',
      display: { xs: 'inline-flex', md: 'none' },
    },
    modal: {
      width: { xs: 343, md: 560 },
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxSizing: 'border-box',
      p: '1rem',
      outline: 'none',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1.5rem',
      mb: '1.5rem',
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.6,
      letterSpacing: '0.15px',
      color: palette?.text?.primary,
    },
    closeButton: {
      color: palette?.grey?.[500] ?? palette?.text?.secondary,
      flexShrink: 0,
      mr: '-0.25rem',
    },
    body: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontStyle: 'normal',
      fontSize: '1rem',
      color: palette?.text?.primary,
      mb: '1.5rem',
      lineHeight: '180%',
      letterSpacing: '0.15px',
    },
    footer: {
      display: 'flex',
      gap: '0.75rem',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    buttonSx: {
      width: '90px',
      maxWidth: '90px',
      height: '42px',
      minHeight: '42px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: palette?.primary?.dark,
        borderColor: palette?.primary?.dark,
      },
      '&.MuiButton-outlinedPrimary:hover': {
        backgroundColor: 'transparent',
        borderColor: palette?.primary?.main,
      },
    },
  };
};
